import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgXbold = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 256 256",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 24,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M66.08,66.08L189.92,189.92M189.92,66.08L66.08,189.92"
	})
});
export default SvgXbold;
